import api from '..'

export class AccountService {
  static async findAll() {
    const response = await api.get('/accounts')
    return response.data
  }

  static async findInterests(params: {
    organizationId?: string
    otm?: string
    from?: string
    to?: string
    page?: number
    perPage?: number
  } = {}) {
    const response = await api.get('/accounts/interests/list', { params })
    return response.data
  }

  static invalidateCache() {
    return
  }
}
